{
  "contract_version": 4,
  "identity": {
    "anonymous_id": "segment_anonymous_id",
    "user_id": "auth0_database_id_without_prefix_else_full_subject",
    "user_id_pattern": "^(?:[0-9a-f]{24}|[A-Za-z0-9_-]+\\|[^\\s|][^\\s]{0,254})$",
    "full_auth0_id_trait": "auth0Id",
    "group_id": "auth0_organization_id",
    "forbidden_group_ids": [
      "salesforce_account_group_id"
    ],
    "journey_keys": [
      "signup_session_id",
      "correlation_id"
    ],
    "idempotency_key": "messageId"
  },
  "attribution_modes": {
    "direct": "Adds each attribution_fields property unprefixed (browser events that read the attribution cookies).",
    "touch": "Adds first_touch_<field> and last_touch_<field> for each attribution_fields property (server events that inherit attribution stored on the account)."
  },
  "internal_only_policy": "Events with internal_only true, and properties listed in internal_only_properties, go to the warehouse only. They must never be mapped to GA4 or any marketing destination until the owner lifts the restriction.",
  "definitions": {
    "attribution_fields": {
        "utm_source": { "type": "string", "maxLength": 512 },
        "utm_medium": { "type": "string", "maxLength": 512 },
        "utm_campaign": { "type": "string", "maxLength": 512 },
        "utm_term": { "type": "string", "maxLength": 512 },
        "utm_content": { "type": "string", "maxLength": 512 },
        "utm_id": { "type": "string", "maxLength": 512 },
        "utm_source_platform": { "type": "string", "maxLength": 512 },
        "utm_creative_format": { "type": "string", "maxLength": 512 },
        "utm_marketing_tactic": { "type": "string", "maxLength": 512 },
        "gclid": { "type": "string", "maxLength": 512 },
        "gbraid": { "type": "string", "maxLength": 512 },
        "wbraid": { "type": "string", "maxLength": 512 },
        "gad_source": { "type": "string", "maxLength": 512 },
        "gad_campaignid": { "type": "string", "maxLength": 512 },
        "dclid": { "type": "string", "maxLength": 512 },
        "msclkid": { "type": "string", "maxLength": 512 },
        "li_fat_id": { "type": "string", "maxLength": 512 },
        "fbclid": { "type": "string", "maxLength": 512 },
        "ttclid": { "type": "string", "maxLength": 512 },
        "twclid": { "type": "string", "maxLength": 512 },
        "rdt_cid": { "type": "string", "maxLength": 512 },
        "epik": { "type": "string", "maxLength": 512 },
        "ScCid": { "type": "string", "maxLength": 512 },
        "yclid": { "type": "string", "maxLength": 512 },
        "sacid": { "type": "string", "maxLength": 512 },
        "fbc": { "type": "string", "maxLength": 512, "description": "Meta _fbc cookie (carries fbclid after the URL param is gone). Snapshot of the ad platform cookie, not a URL touch." },
        "fbp": { "type": "string", "maxLength": 512, "description": "Meta _fbp browser id cookie. Snapshot of the ad platform cookie, not a URL touch." },
        "gcl_aw": { "type": "string", "maxLength": 512, "description": "Google Ads _gcl_aw cookie (stored gclid). Snapshot of the ad platform cookie, not a URL touch." },
        "gcl_gb": { "type": "string", "maxLength": 512, "description": "Google Ads _gcl_gb cookie (stored gbraid). Snapshot of the ad platform cookie, not a URL touch." },
        "uet_msclkid": { "type": "string", "maxLength": 512, "description": "Microsoft _uetmsclkid cookie (stored msclkid). Snapshot of the ad platform cookie, not a URL touch." },
        "landing_page": { "type": "string", "maxLength": 512, "description": "Origin and path only; query string and fragment stripped." },
        "referrer": { "type": "string", "maxLength": 512, "description": "Origin and path only; query string and fragment stripped." }
    },
    "ecommerce_product": {
      "type": "object",
      "additionalProperties": false,
      "required": ["product_id", "name"],
      "properties": {
        "product_id": { "type": "string", "minLength": 1, "maxLength": 64 },
        "sku": { "type": "string", "maxLength": 64 },
        "category": { "type": "string", "maxLength": 64 },
        "name": { "type": "string", "minLength": 1, "maxLength": 128 },
        "brand": { "type": "string", "maxLength": 64 },
        "variant": { "type": "string", "maxLength": 64 },
        "price": { "type": "number", "minimum": 0 },
        "quantity": { "type": "integer", "minimum": 1 },
        "coupon": { "type": "string", "maxLength": 64 },
        "position": { "type": "integer", "minimum": 0 }
      }
    }
  },
  "calls": [
    {
      "name": "Identify",
      "type": "IDENTIFY",
      "version": 3,
      "json_schema": {
        "type": "object",
        "additionalProperties": true,
        "properties": {
          "userId": {
            "type": "string",
            "pattern": "^(?:[0-9a-f]{24}|[A-Za-z0-9_-]+\\|[^\\s|][^\\s]{0,254})$",
            "description": "auth0|<24hex> database users: the 24-hex id with auth0| stripped. Other providers (social, SSO): the full Auth0 subject unchanged. The full subject always goes in traits.auth0Id."
          },
          "traits": {
            "type": "object",
            "additionalProperties": true,
            "description": "Approved CDP traits may contain PII; they must never be forwarded wholesale to GA4."
          }
        },
        "required": [
          "userId",
          "traits"
        ]
      }
    },
    {
      "name": "Group",
      "type": "GROUP",
      "version": 1,
      "json_schema": {
        "type": "object",
        "additionalProperties": true,
        "properties": {
          "groupId": {
            "type": "string",
            "minLength": 1,
            "description": "Exact Auth0 organization id for one merchant customer boundary."
          },
          "traits": {
            "type": "object",
            "additionalProperties": true
          }
        },
        "required": [
          "groupId"
        ]
      }
    }
  ],
  "events": [
    {
      "name": "Account Created",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "attribution": "touch",
      "required_context": ["groupId"],
      "required_properties": ["account_name", "account_type"],
      "properties": {
        "account_name": { "type": "string", "minLength": 1 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor"] }
      }
    },
    {
      "name": "Account Deleted",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "required_context": ["groupId"],
      "required_properties": ["deletion_reason"],
      "properties": {
        "deletion_reason": { "type": "string", "enum": ["customer_request", "contract_end", "administrative", "unknown"] }
      }
    },
    {
      "name": "Signed Up",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 3,
      "attribution": "touch",
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["type", "account_type", "auth_method"],
      "properties": {
        "type": { "type": "string", "enum": ["organic", "invited", "admin", "migration", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor"] },
        "auth_method": { "type": "string", "enum": ["password", "passwordless", "social", "sso", "unknown"] },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "Signed In",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["auth_method", "account_type"],
      "properties": {
        "auth_method": { "type": "string", "enum": ["password", "passwordless", "social", "sso", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Signed Out",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["account_type"],
      "properties": {
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Invite Sent",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 1,
      "required_context": ["groupId"],
      "required_properties": ["invitee_role"],
      "properties": {
        "invitee_role": { "type": "string", "enum": ["owner", "admin", "developer", "member", "viewer", "unknown"] },
        "invite_channel": { "type": "string", "enum": ["email", "link", "admin", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Account Added User",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 1,
      "required_context": ["groupId"],
      "required_properties": [],
      "properties": {
        "role": { "type": "string", "enum": ["owner", "admin", "developer", "member", "viewer", "unknown"] },
        "membership_source": { "type": "string", "enum": ["signup", "invite", "admin", "migration", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Account Removed User",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 1,
      "required_context": ["groupId"],
      "required_properties": [],
      "properties": {
        "removal_reason": { "type": "string", "enum": ["member_request", "admin", "account_closed", "security", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Trial Started",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["trial_start_date", "trial_end_date", "trial_plan_name", "account_type"],
      "properties": {
        "trial_start_date": { "type": "string", "format": "date-time" },
        "trial_end_date": { "type": "string", "format": "date-time" },
        "trial_plan_name": { "type": "string", "maxLength": 64 },
        "product": { "type": "string", "maxLength": 64 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Trial Ended",
      "domain": "b2b_saas",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["trial_start_date", "trial_end_date", "trial_plan_name", "trial_outcome", "account_type"],
      "properties": {
        "trial_start_date": { "type": "string", "format": "date-time" },
        "trial_end_date": { "type": "string", "format": "date-time" },
        "trial_plan_name": { "type": "string", "maxLength": 64 },
        "trial_outcome": { "type": "string", "enum": ["activated", "expired", "cancelled", "unknown"] },
        "product": { "type": "string", "maxLength": 64 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Product List Viewed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["list_id", "category", "products"],
      "properties": {
        "list_id": { "type": "string", "maxLength": 64 },
        "category": { "type": "string", "maxLength": 64 },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } }
      }
    },
    {
      "name": "Product Viewed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["product_id", "name"],
      "properties": {
        "product_id": { "type": "string", "maxLength": 64 },
        "name": { "type": "string", "maxLength": 128 },
        "category": { "type": "string", "maxLength": 64 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "price": { "type": "number", "minimum": 0 }
      }
    },
    {
      "name": "Product Added",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["cart_id", "product_id", "name", "quantity", "currency", "price"],
      "properties": {
        "cart_id": { "type": "string", "minLength": 1 },
        "product_id": { "type": "string", "maxLength": 64 },
        "name": { "type": "string", "maxLength": 128 },
        "category": { "type": "string", "maxLength": 64 },
        "quantity": { "type": "integer", "minimum": 1 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "price": { "type": "number", "minimum": 0 }
      }
    },
    {
      "name": "Product Removed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["cart_id", "product_id", "name", "quantity", "currency", "price"],
      "properties": {
        "cart_id": { "type": "string", "minLength": 1 },
        "product_id": { "type": "string", "maxLength": 64 },
        "name": { "type": "string", "maxLength": 128 },
        "category": { "type": "string", "maxLength": 64 },
        "quantity": { "type": "integer", "minimum": 1 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "price": { "type": "number", "minimum": 0 }
      }
    },
    {
      "name": "Cart Viewed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["cart_id", "currency", "value", "products"],
      "properties": {
        "cart_id": { "type": "string", "minLength": 1 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "value": { "type": "number", "minimum": 0 },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } }
      }
    },
    {
      "name": "Checkout Started",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["checkout_id", "currency", "value", "products"],
      "properties": {
        "checkout_id": { "type": "string", "minLength": 1 },
        "order_id": { "type": "string", "minLength": 1 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "value": { "type": "number", "minimum": 0 },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } },
        "coupon": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "Checkout Step Viewed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["checkout_id", "step"],
      "properties": {
        "checkout_id": { "type": "string", "minLength": 1 },
        "step": { "type": "integer", "minimum": 1 },
        "step_name": { "type": "string", "enum": ["account", "organization", "payment", "review", "complete"] }
      }
    },
    {
      "name": "Checkout Step Completed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["checkout_id", "step"],
      "properties": {
        "checkout_id": { "type": "string", "minLength": 1 },
        "step": { "type": "integer", "minimum": 1 },
        "step_name": { "type": "string", "enum": ["account", "organization", "payment", "review", "complete"] }
      }
    },
    {
      "name": "Payment Info Entered",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["checkout_id", "payment_method"],
      "properties": {
        "checkout_id": { "type": "string", "minLength": 1 },
        "order_id": { "type": "string", "minLength": 1 },
        "step": { "type": "integer", "minimum": 1 },
        "payment_method": { "type": "string", "enum": ["card", "invoice", "none", "unknown"] },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "value": { "type": "number", "minimum": 0 },
        "coupon": { "type": "string", "maxLength": 64 },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } }
      }
    },
    {
      "name": "Order Completed",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["checkout_id", "order_id", "currency", "revenue", "payment_status", "products"],
      "properties": {
        "checkout_id": { "type": "string", "minLength": 1 },
        "order_id": { "type": "string", "minLength": 1 },
        "affiliation": { "type": "string", "maxLength": 64 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "revenue": { "type": "number", "exclusiveMinimum": 0 },
        "payment_status": { "type": "string", "enum": ["captured", "paid"] },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } },
        "coupon": { "type": "string", "maxLength": 64 },
        "tax": { "type": "number", "minimum": 0 },
        "shipping": { "type": "number", "minimum": 0 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Order Refunded",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["order_id", "refund_id", "currency", "revenue", "originating_payment_status", "refund_status", "products"],
      "properties": {
        "order_id": { "type": "string", "minLength": 1 },
        "refund_id": { "type": "string", "minLength": 1, "maxLength": 128, "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$" },
        "affiliation": { "type": "string", "maxLength": 64 },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "revenue": { "type": "number", "exclusiveMinimum": 0 },
        "originating_payment_status": { "type": "string", "enum": ["captured", "paid"] },
        "refund_status": { "type": "string", "enum": ["refunded", "partially_refunded"] },
        "products": { "type": "array", "minItems": 1, "items": { "$ref": "#/definitions/ecommerce_product" } },
        "coupon": { "type": "string", "maxLength": 64 },
        "tax": { "type": "number", "minimum": 0 },
        "shipping": { "type": "number", "minimum": 0 }
      }
    },
    {
      "name": "Order Cancelled",
      "domain": "ecommerce",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "required_properties": ["order_id", "cancellation_stage"],
      "properties": {
        "order_id": { "type": "string", "minLength": 1 },
        "cancellation_stage": { "type": "string", "enum": ["before_payment", "after_authorization", "after_capture", "unknown"] },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "Form Submitted",
      "domain": "lead",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["form_type", "submission_outcome", "event_id"],
      "properties": {
        "form_type": { "type": "string", "enum": ["webToLead", "signup"] },
        "form_preset": { "type": "string", "maxLength": 64 },
        "submission_outcome": { "type": "string", "enum": ["accepted"] },
        "event_id": { "type": "string", "minLength": 1, "maxLength": 128, "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$" },
        "source_surface": { "type": "string", "maxLength": 64 },
        "product_interest": { "type": "string", "maxLength": 64 },
        "signup_session_id": { "type": "string", "maxLength": 128 },
        "correlation_id": { "type": "string", "maxLength": 256 }
      }
    },
    {
      "name": "Lead Qualified",
      "domain": "lead",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["lead_stage", "product_interest"],
      "properties": {
        "lead_stage": { "type": "string", "enum": ["qualified"] },
        "product_interest": { "type": "string", "maxLength": 64 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] },
        "handoff_reason": { "type": "string", "maxLength": 64, "description": "Why sales took over; values come from the Salesforce handoff field and are not fixed yet." }
      }
    },
    {
      "name": "Lead Converted",
      "domain": "lead",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["lead_stage", "product"],
      "properties": {
        "lead_stage": { "type": "string", "enum": ["converted"] },
        "product": { "type": "string", "maxLength": 64 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] },
        "handoff_reason": { "type": "string", "maxLength": 64, "description": "Why sales took over; values come from the Salesforce handoff field and are not fixed yet." }
      }
    },
    {
      "name": "signup_form_viewed",
      "domain": "form_health",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "source_surface": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "signup_form_started",
      "domain": "form_health",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "source_surface": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "signup_form_validation_failed",
      "domain": "form_health",
      "type": "TRACK",
      "version": 3,
      "internal_only_properties": ["error_category", "field_category"],
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type", "error_category"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "error_category": { "type": "string", "enum": ["required", "format", "eligibility", "captcha", "unknown"] },
        "field_category": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "signup_form_submit_attempted",
      "domain": "form_health",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type", "status"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "status": { "type": "string", "enum": ["attempted"] },
        "correlation_id": { "type": "string", "maxLength": 256 }
      }
    },
    {
      "name": "signup_form_submit_accepted",
      "domain": "form_health",
      "type": "TRACK",
      "version": 3,
      "attribution": "direct",
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type", "status"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "status": { "type": "string", "enum": ["accepted"] },
        "correlation_id": { "type": "string", "maxLength": 256 }
      }
    },
    {
      "name": "signup_form_submit_failed",
      "domain": "form_health",
      "type": "TRACK",
      "version": 3,
      "internal_only_properties": ["error_category"],
      "required_context": [],
      "required_properties": ["event_version", "journey", "form_type", "status", "error_category"],
      "properties": {
        "event_version": { "type": "integer", "enum": [2] },
        "journey": { "type": "string", "maxLength": 64 },
        "form_type": { "type": "string", "maxLength": 64 },
        "status": { "type": "string", "enum": ["failed"] },
        "error_category": { "type": "string", "enum": ["network", "validation", "duplicate", "service", "unknown"] },
        "correlation_id": { "type": "string", "maxLength": 256 }
      }
    },
    {
      "name": "Signup Blocked",
      "domain": "form_health",
      "type": "TRACK",
      "version": 2,
      "internal_only": true,
      "required_context": [],
      "required_properties": ["block_reason", "journey"],
      "properties": {
        "block_reason": { "type": "string", "enum": ["duplicate_subscription", "identity_conflict", "eligibility", "unknown"] },
        "journey": { "type": "string", "maxLength": 64 },
        "product": { "type": "string", "maxLength": 64 }
      }
    },
    {
      "name": "Subscription Activated",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["product", "plan", "activation_type", "activation_id", "account_type"],
      "properties": {
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "activation_type": { "type": "string", "enum": ["paid", "payg", "trial", "free"] },
        "activation_id": { "type": "string", "minLength": 1 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Contributor Enrolled",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "required_properties": ["product", "enrollment_id"],
      "properties": {
        "product": { "type": "string", "maxLength": 64 },
        "enrollment_id": { "type": "string", "minLength": 1 },
        "account_type": { "type": "string", "enum": ["contributor"] }
      }
    },
    {
      "name": "First API Request Succeeded",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 2,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["product", "plan", "request_surface", "account_type"],
      "properties": {
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "request_surface": { "type": "string", "enum": ["api", "sdk", "console", "example", "unknown"] },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Subscription Started",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 1,
      "attribution": "touch",
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["subscription_id", "product", "plan", "account_type"],
      "properties": {
        "subscription_id": { "type": "string", "minLength": 1, "maxLength": 128, "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$" },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "billing_interval": { "type": "string", "enum": ["month", "year", "usage", "none", "unknown"] },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "mrr": { "type": "number", "minimum": 0 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    },
    {
      "name": "Subscription Changed",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 1,
      "attribution": "touch",
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["subscription_id", "product", "plan", "previous_plan", "direction", "account_type"],
      "properties": {
        "subscription_id": { "type": "string", "minLength": 1, "maxLength": 128, "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$" },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "billing_interval": { "type": "string", "enum": ["month", "year", "usage", "none", "unknown"] },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "mrr": { "type": "number", "minimum": 0 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] },
        "previous_plan": { "type": "string", "maxLength": 64 },
        "previous_mrr": { "type": "number", "minimum": 0 },
        "direction": { "type": "string", "enum": ["upgrade", "downgrade", "lateral"] }
      }
    },
    {
      "name": "Subscription Cancelled",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 1,
      "attribution": "touch",
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["subscription_id", "product", "plan", "cancellation_type", "account_type"],
      "properties": {
        "subscription_id": { "type": "string", "minLength": 1, "maxLength": 128, "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$" },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "billing_interval": { "type": "string", "enum": ["month", "year", "usage", "none", "unknown"] },
        "currency": { "type": "string", "pattern": "^[A-Z]{3}$" },
        "mrr": { "type": "number", "minimum": 0 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] },
        "cancellation_type": { "type": "string", "enum": ["customer_request", "payment_failure", "administrative", "unknown"] }
      }
    },
    {
      "name": "Lifecycle Stage Changed",
      "domain": "xweather_lifecycle",
      "type": "TRACK",
      "version": 1,
      "required_context": [],
      "group_context": {
        "required_when": { "property": "account_type", "values": ["business"] }
      },
      "required_properties": ["stage", "previous_stage", "account_type"],
      "properties": {
        "stage": { "type": "string", "enum": ["inactive", "first_login", "first_success", "activated", "engaged", "risk"] },
        "previous_stage": { "type": "string", "enum": ["none", "inactive", "first_login", "first_success", "activated", "engaged", "risk"] },
        "product": { "type": "string", "maxLength": 64 },
        "plan": { "type": "string", "maxLength": 64 },
        "account_type": { "type": "string", "enum": ["business", "individual", "contributor", "unknown"] }
      }
    }
  ]
}
